import { combineReducers } from 'redux'
import { CategoryTypes } from '../../action_types'
import { arrayToObject, removeItem, insertItem, updateObjectInArray } from 'src/utils/helpers'

function categories(state = {}, action) {
  switch (action.type) {
    case CategoryTypes.GET_CATEGORY_SUCCESS:
      return { ...state, [action.category_type]: action.data }
    default:
      return state
  }
}

export default combineReducers({
    categories,
})
